'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';
import useFormItemContext from './Item/context.js';
import Typography from '../../Typography/index.js';
import { colors } from '../../Colors/index.js';

var Label = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    margin-bottom: 6px;\n    ", "\n"], ["\n    display: inline-block;\n    margin-bottom: 6px;\n    ", "\n"])), function (_a) {
    var requiredPosition = _a.requiredPosition, isRequired = _a.isRequired;
    return isRequired
        ? requiredPosition === 'left'
            ? "\n    &::before {\n        content: '*';\n        color: ".concat(colors.error[40], ";\n        margin-right: 4px;\n    }\n    ")
            : "\n    &::after {\n        content: '*';\n        color: ".concat(colors.error[40], ";\n        margin-left: 4px;\n    }\n    ")
        : '';
});
var FormLabel = function (props) {
    var children = props.children, _a = props.requiredPosition, requiredPosition = _a === void 0 ? 'left' : _a, require = props.require;
    var rules = useFormItemContext().rules;
    var isRequired = rules.some(function (rule) { return rule.type === 'required'; });
    if (typeof require !== 'undefined') {
        isRequired = require;
    }
    return (React__default.createElement(Label, { variant: 'label', name: 'label', size: 'medium', color: colors.grey[20], isRequired: isRequired, requiredPosition: requiredPosition }, children));
};
var templateObject_1;

export { FormLabel as default };
//# sourceMappingURL=Label.js.map
